var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8294 24.4283C8.30908 23.2771 5.7974 19.8571 5.18149 16.2732C3.48206 6.38096 14.0099 -2.54454 24.5242 2.41166C24.6487 4.63348 23.6169 7.79517 20.7854 8.74539C34.8396 17.6182 22.8237 35.7942 8.09517 29.8175C5.40832 28.4472 6.84268 25.9422 9.71555 27.3931C12.9237 28.4994 17.0925 28.4994 19.7194 27.049C21.4339 26.1467 22.9017 24.8388 23.9951 23.2394C24.3866 22.6446 24.726 22.017 25.0094 21.3638C25.2321 20.8393 25.9498 18.6769 25.3928 18.4408C25.2533 18.3824 25.1799 18.5477 25.1417 18.7027C24.7807 20.1115 24.09 21.4143 23.1265 22.5036C21.9654 23.8573 20.4685 24.8818 18.7862 25.4741C16.6859 26.2394 14.2517 26.336 10.9045 25.6038C11.1256 25.3646 11.569 24.6991 11.8263 24.4283H11.8294ZM21.532 3.30038C21.587 3.62408 21.6188 3.9513 21.6271 4.27953C21.6853 4.99913 21.5752 5.7224 21.3057 6.39213C21.0361 7.06185 20.6144 7.65966 20.0739 8.13826C19.8377 8.37491 19.569 8.62086 19.2704 8.87611C23.2397 11.3439 25.3127 16.7408 23.0087 20.5128C19.8992 25.595 13.737 24.4397 10.3712 20.9597C6.84682 17.317 7.31392 12.6036 9.84524 9.11018C11.2134 7.30623 12.9802 5.84314 15.0076 4.83528C17.0349 3.82742 19.2679 3.3021 21.532 3.30038Z",
    fill: "#96CB4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56933 14.4553C10.3248 6.91146 19.0033 5.41819 22.2285 15.4717C24.8312 25.8057 8.3711 23.5565 9.56933 14.4553ZM16.6481 19.4156C23.5017 19.6657 20.2175 12.6567 15.7181 11.1076C11.2584 9.57248 8.77878 19.4151 16.6481 19.4156Z",
    fill: "#333230"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/site.012130c1dea0dbb04f4f701414dd4430.svg";
export { ForwardRef as ReactComponent };